import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import omit from 'lodash/fp/omit';

const omitProps = compose(mapProps, omit);

export default omitProps;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/omitProps.js